import React, { useState, useEffect } from "react";
import Layout from "../components/Layout/Layout";
import { useParams, useNavigate } from "react-router-dom";
import axios from "axios";
import toast from "react-hot-toast";
// import ProductFilterSort from "../components/ProductFilterSort";
import { useProductFilter } from "../hooks/useProductFilter";
import { getImageUrl, FALLBACK_IMAGE } from "../utils/imageHelper";
import ProductFilterSort from "../components/ProductFilter";

const CategoryProduct = () => {
  const params = useParams();
  const navigate = useNavigate();
  const [products, setProducts] = useState([]);
  const [category, setCategory] = useState({});
  const [loading, setLoading] = useState(false);

  // Use your custom hook
  const {
    filteredProducts,
    handleFilterChange,
    handleSortChange,
    handleReset,
  } = useProductFilter(products);

  const PALETTE = {
    PRIMARY_BLUE: "#6A9DD5",
    DARK_NAVY: "#1C2E4A",
    ACCENT_BROWN: "#7C4F2B",
  };

  useEffect(() => {
    if (params?.slug) getProductsByCat();
  }, [params?.slug]);

  const getProductsByCat = async () => {
    try {
      setLoading(true);
      const { data } = await axios.get(
        `/api/v1/product/product-category/${params.slug}`
      );
      setProducts(data?.products || []);
      setCategory(data?.category || {});
    } catch (error) {
      console.log(error);
      toast.error("Failed to load products");
    } finally {
      setLoading(false);
    }
  };

  // Calculate dynamic price range
  const getPriceRange = () => {
    if (products.length === 0) return { min: 0, max: 10000 };
    const prices = products.map((p) => p.price);
    return {
      min: Math.min(...prices),
      max: Math.max(...prices),
    };
  };

  return (
    <Layout>
      <section className="w-full py-16">
        <div className="max-w-7xl mx-auto px-6">
          {/* Header */}
          <div className="text-center mb-12">
            <h2
              className="text-3xl font-light tracking-widest uppercase"
              style={{ color: PALETTE.DARK_NAVY }}
            >
              Category — {category?.name}
            </h2>
            <h4 className="mt-3 text-gray-600">
              {filteredProducts?.length} result(s) found
            </h4>

            <div
              className="w-24 h-px mx-auto mt-4"
              style={{ backgroundColor: PALETTE.ACCENT_BROWN }}
            />
          </div>

          <div className="flex flex-col lg:flex-row gap-8">
            {/* Filter Sidebar - Your Reusable Component */}
            {/* <aside className="lg:w-80 flex-shrink-0">
              <ProductFilterSort
                categories={[]} // Empty since this is category-specific page
                priceRange={getPriceRange()}
                onFilterChange={handleFilterChange}
                onSortChange={handleSortChange}
                onReset={handleReset}
              />
            </aside> */}

            {/* Product Grid */}
            <div className="flex-1">
              {loading ? (
                <div className="flex justify-center items-center py-20">
                  <div className="text-gray-500 text-lg">
                    Loading products...
                  </div>
                </div>
              ) : filteredProducts.length === 0 ? (
                <div className="text-center py-20">
                  <p className="text-gray-500 text-lg mb-4">
                    No products found matching your filters
                  </p>
                  {/* <button
                    onClick={handleReset}
                    className="px-6 py-2 bg-blue-600 text-white rounded-md hover:bg-blue-700 transition"
                  >
                    Clear All Filters
                  </button> */}
                </div>
              ) : (
                <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-x-8 gap-y-12">
                  {filteredProducts.map((product) => (
                    <div
                      key={product._id}
                      className="group w-full bg-white overflow-hidden transition-shadow duration-300 hover:shadow-lg"
                    >
                      {/* Product Image */}
                      <div
                        className="relative w-full h-96 overflow-hidden cursor-pointer"
                        onClick={() => navigate(`/product/${product.slug}`)}
                      >
                        <img
                          src={getImageUrl(product.photos?.[0])}
                          onError={(e) => {
                            e.target.src = FALLBACK_IMAGE;
                          }}
                          alt={product.name}
                          className="w-full h-full object-cover transition-transform duration-500 ease-in-out group-hover:scale-105"
                        />
                      </div>

                      {/* Details */}
                      <div className="p-6">
                        <h3 className="text-lg font-semibold text-gray-800 mb-2 tracking-wide">
                          {product.name.length > 30
                            ? `${product.name.slice(0, 30)}...`
                            : product.name}
                        </h3>

                        <p className="text-sm text-gray-500 mb-3 line-clamp-2">
                          {product.description?.length > 30
                            ? `${product.description.slice(0, 30)}...`
                            : product.description}
                        </p>

                        <div className="flex items-center justify-between mb-4">
                          <span
                            className="text-xl font-bold"
                            style={{ color: PALETTE.DARK_NAVY }}
                          >
                            {product.price?.toLocaleString("en-IN", {
                              style: "currency",
                              currency: "INR",
                            })}
                          </span>
                        </div>

                        <div className="flex gap-3">
                          <button
                            className="flex-1 py-2 px-4 text-sm tracking-wider uppercase font-bold text-black bg-transparent border-[1px] border-black transition-all duration-300 hover:bg-black hover:text-white"
                            onClick={() => navigate(`/product/${product.slug}`)}
                          >
                            View Details
                          </button>
                        </div>
                      </div>
                    </div>
                  ))}
                </div>
              )}
            </div>
          </div>
        </div>
      </section>
    </Layout>
  );
};

export default CategoryProduct;
